export async function getPublicContacts() {
  const response = await fetch("/api/contacts");
  if (!response.ok) {
    throw new Error("Не удалось загрузить контакты");
  }
  return response.json();
}

export async function getContactsConfig() {
  const response = await fetch("/api/admin/contacts");
  if (!response.ok) {
    throw new Error("Не удалось загрузить настройки контактов");
  }
  return response.json();
}

export async function saveContactsConfig(roleIds) {
  const response = await fetch("/api/admin/contacts", {
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(roleIds),
  });
  if (!response.ok) {
    throw new Error("Не удалось сохранить настройки контактов");
  }
}

export async function getAvailableRoles() {
  const response = await fetch("/api/admin/roles");
  if (!response.ok) {
    throw new Error("Не удалось загрузить роли");
  }
  const data = await response.json();
  return Array.isArray(data) ? data.filter((role) => !role.systemRole) : [];
}

export const PLACEHOLDER_AVATAR = "/avatar-placeholder.svg";